(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SubscriptionPackageSearch', SubscriptionPackageSearch);

    SubscriptionPackageSearch.$inject = ['$resource'];

    function SubscriptionPackageSearch($resource) {
        var resourceUrl = 'api/_search/subscription-packages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
